import React, { Component } from 'react';
import { connect } from 'react-redux';

import { CSSTransitionGroup } from 'react-transition-group';
import MediaQuery from 'react-responsive';

import { reduxForm, Field, change } from 'redux-form';
import { compose } from 'redux';

import ReactPhoneInput from 'helpers/reduxFormMaterialUiNext/ReactPhoneInput';
import TextField from 'helpers/reduxFormMaterialUiNext/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import OutlinedSelect from 'helpers/reduxFormMaterialUiNext/OutlinedSelect';

import PropertyUnitSelector from 'components/shared/PropertyUnitSelector';
import MultiSelectExtended from 'components/shared/MultiSelectExtended';
import TenantResidentVerbiageHelper from 'components/shared/TenantResidentVerbiageHelper';
import { DateTimePickerRedux } from 'helpers/reduxFormMaterialUiNext/DateTimePicker';
import { extractTenants } from 'helpers/tenantExtraction';
import * as validator from 'helpers/Validator';
import { deepDiver } from 'helpers/utilities';

import {
  getProperties,
  getUnits,
  getActiveLeaseOfUnit,
  clearActiveLeaseOfUnit,
  showUnits,
} from 'actions/landlordPropertiesActions';

const changeFieldValue = (field, value) => {
  return dispatch => {
    return dispatch(change('add_visitor', field, value));
  };
};

let VisitorsForm = class extends Component {
  render() {
    const style = {
      receipt_header: {
        backgroundColor: '#f1f1f1',
        padding: '5px 10px',
        fontSize: '14px',
        fontWeight: '800',
        borderRadius: '8px',
      },
    };
    return (
      <div className="row">
        <div className="row" style={style.receipt_header}>
          <div className="col-xs-12">
            <p style={{ margin: '0', textAlign: 'center' }}> VISITOR DETAILS </p>
          </div>
        </div>

        <div className="row" style={{ padding: '0px 20px', marginTop: '20px' }}>
          <div className="col-sm-6 col-sm-offset-3" style={{ marginBottom: '20px' }}>
            <Field
              name="visitor_type"
              component={OutlinedSelect}
              label="Visitor Type"
              style={{
                fontSize: '14px',
                width: '100%',
              }}
              validate={[validator.required]}
            >
              <MenuItem key="vtype_1" value={0}>
                Contractor
              </MenuItem>
              <MenuItem key="vtype_2" value={1}>
                Delivery
              </MenuItem>
              <MenuItem key="vtype_3" value={2}>
                Realtor
              </MenuItem>
              <MenuItem
                value={3}
                primaryText={
                  <span>
                    <TenantResidentVerbiageHelper capitalize /> Guest
                  </span>
                }
              />
              <MenuItem
                value={4}
                primaryText={
                  <span>
                    <TenantResidentVerbiageHelper capitalize /> Service
                  </span>
                }
              />
            </Field>
          </div>
          <div className="col-sm-6" style={{ textAlign: 'center', marginBottom: '20px' }}>
            <Field
              name="first_name"
              type="text"
              component={TextField}
              label="First Name"
              variant="outlined"
              style={{
                fontSize: '14px',
                width: '100%',
              }}
              validate={[validator.required]}
            />
          </div>
          <div className="col-sm-6" style={{ textAlign: 'center', marginBottom: '20px' }}>
            <Field
              name="last_name"
              type="text"
              component={TextField}
              label="Last Name"
              variant="outlined"
              style={{
                fontSize: '14px',
                width: '100%',
              }}
              validate={[validator.required]}
            />
          </div>
          <div className="col-sm-6" style={{ textAlign: 'center', marginBottom: '20px' }}>
            <Field
              name="email"
              type="email"
              component={TextField}
              label="Email"
              variant="outlined"
              style={{
                fontSize: '14px',
                width: '100%',
              }}
              validate={[validator.validEmail]}
            />
          </div>
          <div className="col-sm-6" style={{ textAlign: 'center', marginBottom: '20px' }}>
            <Field
              name="phone_number"
              type="tel"
              component={ReactPhoneInput}
              label="Phone Number"
              style={{
                fontSize: '14px',
                width: '100%',
              }}
              validate={[validator.required, validator.validInternationalPhoneNumber]}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6" style={{ marginTop: '15px' }}>
            <Field
              name="expected_arrival_at"
              component={DateTimePickerRedux}
              label="Expected Arrival"
              fullWidth
              validate={[validator.required]}
              style={{ fontSize: '14px' }}
            />
          </div>
          <div className="col-sm-6" style={{ marginTop: '15px' }}>
            <Field
              name="expected_departure_at"
              component={DateTimePickerRedux}
              label="Expected Departure"
              fullWidth
              validate={[validator.required]}
              style={{ fontSize: '14px' }}
            />
          </div>
          <div className="col-xs-12" style={{ marginTop: '2px' }}>
            <Field
              name="notes"
              component={TextField}
              label="Notes"
              multiLine
              fullWidth
              rows={1}
              style={{ fontSize: '14px' }}
            />
          </div>
        </div>
      </div>
    );
  }
};

let AddVisitorForm = class AddVisitorForm extends Component {
  constructor(props) {
    super(props);
    this.state = { showTenant: false, showVisitors: false };
  }

  fetchActiveLeaseOfUnit = unit => {
    this.props.getActiveLeaseOfUnit(unit).then(result => {
      if (!result.value) {
        this.setState({ showVisitors: true });
      }
      this.props.changeFieldValue('unit_active_lease', result.value);
    });
  };

  onPropertyChange = propertyId => {
    this.setState({ showTenant: false, showVisitors: false });
    this.props.getUnits(propertyId.value, { for_multiselect: true }).then(response => {
      if (!deepDiver(response, 'value.data.0.label')) {
        this.onUnitChange(deepDiver(response, 'value.data.0'));
      }
    });
  };

  onUnitChange = event => {
    this.clearSelections();
    this.props.allowVisitorSubmit(true);

    if (!event.value) {
      this.setState({ showTenant: false });
      return;
    }
    this.clearSelections();
    this.fetchActiveLeaseOfUnit(event.value);
    this.setState({ showTenant: true });
  };

  clearSelections = () => {
    this.props.clearActiveLeaseOfUnit();
    this.props.changeFieldValue('tenant', null);
  };

  render() {
    const style = {
      receipt_header: {
        margin: '0px -20px 10px -20px',
        backgroundColor: '#f1f1f1',
        padding: '5px 10px',
        fontSize: '14px',
        fontWeight: '800',
        borderRadius: '8px',
      },
    };

    let tenants = extractTenants(this.props.unitActiveLease);

    return (
      <form handleSubmit={this.onSubmit} autoComplete="off">
        <div className="row">
          {this.props.showPropertySelector && (
            <div>
              <div className="row" style={style.receipt_header}>
                <div className="col-xs-12">
                  <p style={{ margin: '0', textAlign: 'center' }}> VISITING UNIT DETAILS </p>
                </div>
              </div>
              <div className="row" style={{ marginBottom: '20px' }}>
                <PropertyUnitSelector
                  properties={this.props.properties}
                  units={this.props.units}
                  onPropertyChange={this.onPropertyChange}
                  propertyInnerDivStyle={{
                    width: '100%',
                    fontSize: '14px',
                    fontWeight: '100 !important',
                  }}
                  propertyMenuStyle={{ minWidth: '250px', fontSize: '14px' }}
                  propertyStyle={{ textAlign: 'left', fontSize: '14px' }}
                  unitMenuStyle={{ fontSize: '14px' }}
                  unitStyle={{ textAlign: 'left', fontSize: '14px' }}
                  onUnitChange={this.onUnitChange}
                  allowNone
                />
                <CSSTransitionGroup
                  transitionName="show_dropdown_28px"
                  transitionEnterTimeout={500}
                  transitionLeaveTimeout={500}
                >
                  {this.state.showTenant &&
                    tenants.length > 0 && (
                      <div className="col-sm-12" style={{ margin: '30px 0 15px' }}>
                        <Field
                          name="tenant"
                          data={tenants || []}
                          onChange={() => this.setState({ showVisitors: true })}
                          component={MultiSelectExtended}
                          hintText={
                            <span>
                              <TenantResidentVerbiageHelper capitalize />s
                            </span>
                          }
                          innerDivStyle={{
                            width: '100%',
                            fontSize: '15px',
                            fontWeight: '100 !important',
                          }}
                          menuStyle={{ minWidth: '250px', fontSize: '14px' }}
                          style={{ fontSize: '14px' }}
                          fullWidth
                          validate={[validator.required]}
                          disabled={!this.props.unitActiveLease}
                        />
                      </div>
                    )}
                </CSSTransitionGroup>
              </div>
            </div>
          )}

          <MediaQuery query="(max-device-width: 750px)">
            <CSSTransitionGroup
              transitionName="show_visitors_form"
              transitionEnterTimeout={500}
              transitionLeaveTimeout={500}
            >
              {this.state.showVisitors && <VisitorsForm />}
            </CSSTransitionGroup>
          </MediaQuery>

          <MediaQuery query="(min-device-width: 750px)">
            <CSSTransitionGroup
              transitionName="show_visitors_form_mobile"
              transitionEnterTimeout={500}
              transitionLeaveTimeout={500}
            >
              {this.state.showVisitors && <VisitorsForm />}
            </CSSTransitionGroup>
          </MediaQuery>
        </div>
      </form>
    );
  }
};

const mapStateToProps = (state, ownProps) => {
  return {
    form: ownProps.formName,
    properties: state.landlordProperties.properties,
    units: state.landlordProperties.units,
    unitActiveLease: state.landlordProperties.unitActiveLease,
  };
};

export default compose(
  connect(mapStateToProps, {
    getActiveLeaseOfUnit,
    getUnits,
    getProperties,
    clearActiveLeaseOfUnit,
    showUnits,
    changeFieldValue,
  }),
  reduxForm({
    destroyOnUnmount: true,
  })
)(AddVisitorForm);
